"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedModelSigningEntity = void 0;
const Field_type_1 = require("../../../types/Field.type");
const SigningEntity_1 = require("../../enm/SigningEntity");
exports.NestedModelSigningEntity = {
    priority: 1,
    label: 'fields.enm.signing_entity.label',
    fallbackLabel: 'In the Nested Model setup, please clarify who enters into the legal agreement with a merchant?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.entrust_other_contracted_entities', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: SigningEntity_1.SigningEntityRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
